import { Attachment } from "./types";

export const defaultPosition = {
  artwork: "oeuvresPhotoFaceOeuvre",
  photography: "photographyPhotoFace",
  document: "documentsPhotoCouverture",
  bibliography: "bibliographieDescriptionPhotoCouverture",
  sample: "exemplairedansestampesmultiplesdescriptionphotoexemplaire",
  audiovisual: "audiovisuelDescriptionPhoto",
  multipleprint: "estampesMultiplesDescriptionPhotoFaceOeuvre",
  author: "authorPhotoPortrait",
  auction: "auctionPhotoExterieur",
  exhibition: "exhibitionPhotoExterieur",
  writing: "ecritsPhotoPremierePage",
  multiplesample: "exemplairedansestampesmultiplesdescriptionphotoexemplaire",
} as const;

export const defaultPositionValues = Object.values(defaultPosition);

export const optionsPosition = {
  author: ["authorPhotoPortrait", "authorPhotoOther"],
  auction: ["auctionPhotoExterieur", "auctionPhotoAutres"],
  exhibition: ["exhibitionPhotoExterieur", "exhibitionPhotoAutres"],
  photos: ["photosPhoto", "photosPhotoDos", "photosPhotoVariante", "autres"],
  photography: [
    "photographyPhotoFace",
    "photographyPhotoDos",
    "photographyPhotoVariante",
    "photographyPhotoAutre",
  ],
  artwork: [
    "oeuvresPhotoFaceOeuvre",
    "oeuvresPhotoDosOeuvre",
    "oeuvresPhotoState",
    "oeuvresRegiePhotoCadre",
    "oeuvresRegiePhotoCaisse",
    "oeuvresPhotoAutres",
  ],
  bibliography: [
    "bibliographieDescriptionPhotoCouverture",
    "bibliographieDescriptionPhotoAutresPages",
  ],
  audiovisual: [
    "audiovisuelDescriptionPhoto",
    "audiovisuelDescriptionPhotoSupplementaire",
  ],
  sample: [
    "exemplaireDansEstampesMultiplesDescriptionPhotoExemplaire",
    "exemplaireDansEstampesMultiplesDescriptionPhotoCachetSignature",
  ],
  multipleprint: [
    "estampesMultiplesDescriptionPhotoFaceOeuvre",
    "estampesMultiplesDescriptionPhotoDosOeuvre",
    "estampesMultiplesDescriptionPhotoDocumentAnnexe",
    "estampesMultiplesDescriptionPhotoEtat",
  ],
  writing: ["ecritsPhotoPremierePage", "ecritsPhotoAutresPage"],
  document: ["documentsPhotoCouverture", "documentsPhotoAutresPages"],
  ensemble: [
    "ensemblesDescriptionLogoAuteur",
    "ensemblesDescriptionEnsembleImage",
  ],
  collector: [],
} as const;

export const mainPositions = [
  "oeuvresPhotoFaceOeuvre",
  "estampesMultiplesDescriptionPhotoFaceOeuvre",
  "photographyPhotoFace",
  "audiovisuelDescriptionPhoto",
  "ecritsPhotoPremierePage",
  "documentsPhotoCouverture",
];

export const isMainPosition = (position: string): boolean =>
  mainPositions.includes(position);

export type PublicAttachmentFormat =
  | "mediumPublicUrl"
  | "largePublicUrl"
  | "publicUrl";

export type TypeDefaultImage = keyof typeof defaultPosition;
export type TypeOptionPosition = keyof typeof optionsPosition;

export function getDefaultImage(
  images: Attachment[],
  type: TypeDefaultImage,
  size: PublicAttachmentFormat = "mediumPublicUrl",
) {
  if (images.length === 0) {
    return null;
  }

  const defaultImage = images.find(
    (image) =>
      image.details &&
      JSON.parse(image.details) &&
      JSON.parse(image.details).defaultImage,
  );
  if (defaultImage) {
    return defaultImage[size];
  }

  const imageDefaultPosition = images.find(
    (image) => image.position === defaultPosition[type],
  );

  if (imageDefaultPosition) {
    return imageDefaultPosition[size];
  }

  return images[0][size];
}

export function getDefaultAttachment(
  attachments: Attachment[],
  type: keyof typeof defaultPosition,
): Attachment | null {
  if (attachments.length === 0) {
    return null;
  }
  const defaultImage = attachments.find(
    (attachment) =>
      attachment.details &&
      JSON.parse(attachment.details) &&
      JSON.parse(attachment.details).defaultImage,
  );
  if (defaultImage) {
    return defaultImage;
  }

  const imageDefaultPosition = attachments.find(
    (attachment) => attachment.position === defaultPosition[type],
  );

  if (imageDefaultPosition) {
    return imageDefaultPosition;
  }

  return attachments[0];
}
